import OhsContractorLookup from 'contractor/models/OhsContractorLookUp';
import { ApiResListsType, OhsApiRequestName, RequestType } from 'global-services/api/OhsApiModels';
import OhsApiRequest from 'global-services/api/OhsApiRequest';
import { ModuleType } from 'global-services/constants/OhsObject';
import { OhsHrLookup } from 'human-resource/models/OhsHumanResourceModels';

export const getHrLookupList = (payload?: any): Promise<ApiResListsType<OhsHrLookup[]> | null> => {
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.WorkManagement,
    OhsApiRequestName.HRLookup,
    payload
  );
};

export const getContractorLookupList = (
  payload?: any
): Promise<ApiResListsType<OhsContractorLookup[]> | null> => {
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.WorkManagement,
    OhsApiRequestName.ContractorLookup,
    payload
  );
};

export const getIncidentLookupList = (): Promise<ApiResListsType<any[]> | null> => {
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.WorkManagement,
    OhsApiRequestName.IncidentLookup,
    { forType: ModuleType.WorkManagement }
  );
};
